import { combineReducers } from 'redux';
import { StoreState } from './types/store-types';

import filesReducer from './files';
import feeReducer from './fee';
import balanceReducer from './balancing';
import operationReducer from './operationReports';
import yieldsReducer from './yields';
import strategiesReducer from './strategies';
import operationEmisoraReducer from './operationEmisora';
import operationHomologationReducer from './operationHomologation';
import documentaryReducer from './documentary';
import clientsReducer from './clients';
import alertsReducer from './alerts';
import globalAppReducer from './globalApp';
import operationAuditsReducer from './operationAudits';
import operationComplianceReducer from './operationCompliance';
import operationSalesReducer from './operationSales';
import blackListReducer from './blackList';
import operationAuditLoadReducer from './operationAuditLoad';
import operationUnusualReducer from './operationUnusual';
import operationFoundsReducer from './operationFounds';
import operationLiquidityReducer from './operationLiquidity';

export default combineReducers<StoreState.All>({
  files: filesReducer,
  blackList: blackListReducer,
  fee: feeReducer,
  balance: balanceReducer,
  yields: yieldsReducer,
  strategies: strategiesReducer,
  operation: operationReducer,
  operationEmisora: operationEmisoraReducer,
  operationHomologation: operationHomologationReducer,
  documentary: documentaryReducer,
  clients: clientsReducer,
  alerts: alertsReducer,
  globalApp: globalAppReducer,
  operationAudits: operationAuditsReducer,
  operationCompliance: operationComplianceReducer,
  operationSales: operationSalesReducer,
  operationAuditLoad: operationAuditLoadReducer,
  operationUnusual: operationUnusualReducer,
  operationFounds: operationFoundsReducer,
  operationLiquidity: operationLiquidityReducer,
});
